import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import MyQnaNew from "./MyQnaNew";
import MyReviewNew from "./MyReviewNew";
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyWrite extends PureComponent {
  state = {
    index: this.props.childProps.index ? this.props.childProps.index : 0,
  };
  componentDidMount = () => {};
  _changeIndex = (index) => {
    const { _myMenu } = this.props.childProps;
    _myMenu(index);
  };
  render() {
    const { index } = this.props.childProps;
    return (
      <Fragment>
        <div className="my_con">
          <div className="my_tab">
            {isMobile ? null : (
              <h3>
                <a href="#" class="btn_back"></a>내가 쓴 글
              </h3>
            )}
            <ul>
              <li>
                <button
                  type="button"
                  className={index === 6 ? "active" : null}
                  onClick={() => this._changeIndex(6)}
                >
                  1:1 문의 내역
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={index === 7 ? "active" : null}
                  onClick={() => this._changeIndex(7)}
                >
                  내가 작성한 리뷰
                </button>
              </li>
            </ul>
          </div>

          {index === 6 ? <MyQnaNew /> : index === 7 ? <MyReviewNew /> : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyWrite)));
